import type React from 'react';

import { toLinearGradient } from '#src/app/shared/components/ScrollContainer';

type GradientOverlaysProps = {
	canScrollLeft: boolean;
	canScrollRight: boolean;
	backgroundColor?: string;
};

export const GradientOverlays: React.FC<GradientOverlaysProps> = ({
	canScrollLeft,
	canScrollRight,
	backgroundColor = '#ffffff',
}) => {
	return (
		<>
			<div
				aria-hidden
				className={canScrollLeft ? 'hidden md:block' : 'hidden'}
				data-testid="gradient-overlay-left"
				sx={{
					position: 'absolute',
					left: 0,
					top: 0,
					bottom: 0,
					width: '50px',
					pointerEvents: 'none',
					zIndex: 10,
					background: toLinearGradient(backgroundColor, 'left'),
				}}
			/>
			<div
				aria-hidden
				className={canScrollRight ? 'hidden md:block' : 'hidden'}
				data-testid="gradient-overlay-right"
				sx={{
					position: 'absolute',
					right: 0,
					top: 0,
					bottom: 0,
					width: '50px',
					pointerEvents: 'none',
					zIndex: 10,
					background: toLinearGradient(backgroundColor, 'right'),
				}}
			/>
		</>
	);
};
